import $ from 'jquery';
import _ from 'underscore';
import moment from 'moment';
import { track } from '@trello/analytics';
import DueDateHelpers from 'app/scripts/views/internal/due-date-helpers.coffee';
import { shouldFireConfetti } from 'app/scripts/views/card/should-fire-confetti';
import confetti from 'canvas-confetti';
import Util from 'app/scripts/lib/util/index.coffee';
import ChecklistView from 'app/scripts/views/checklist/checklist-view.coffee';
import PopOver from 'app/scripts/views/lib/pop-over.coffee';
import log from 'app/scripts/debug/log.coffee';
import DragSort from 'app/scripts/views/lib/drag-sort.coffee';
import DatePickerView from 'app/scripts/views/card/date-picker-view.coffee';
import AddChecklistMenu from 'app/scripts/views/checklist/add-checklist-menu.coffee';

export const renderAddChecklists = function() {
  const cardOver = this.model.isOverLimit('checklists', 'perCard');
  const boardOver = this.model.getBoard().isOverLimit('checklists', 'perBoard');
  const disabled = cardOver || boardOver;
  this.$('.js-add-checklist-menu').toggleClass('disabled', disabled);
  return this;
};

export const renderDueDate = function() {
  const due = this.model.get('due');
  const dueComplete = this.model.get('dueComplete');
  const isTemplate = !!this.model.get('isTemplate');
  this.$('.js-add-due-date').toggleClass('hide', isTemplate);
  if (!due || isTemplate) {
    this.$('.js-card-detail-due-date').addClass('hide');
    return this;
  }
  const dueDateDate = moment(due).calendar();
  const relativeDueDateStatus = DueDateHelpers.relativeInfoForDueDate(
    due,
    dueComplete,
  );
  const classes = [];
  classes.push(DueDateHelpers.classForDueDate(due, dueComplete));
  if (this.model.editable()) {
    classes.push('is-clickable');
  }
  const $badge = this.$('.js-card-detail-due-date-badge')
    .removeClass(function(index: number, css: string) {
      return (css.match(/is-due-\S+/g) || []).join(' ');
    })
    .addClass(classes.join(' '))
    .attr('title', DueDateHelpers.titleForDueDate(due, dueComplete));
  $badge
    .find('.card-detail-badge-due-date-button')
    .toggleClass('js-details-edit-due-date', this.model.editable());
  $badge.find('.js-date-text').text(dueDateDate);
  if (relativeDueDateStatus) {
    $badge
      .find('.js-due-status')
      .removeClass('hide')
      .text(relativeDueDateStatus);
  } else {
    $badge.find('.js-due-status').addClass('hide');
  }
  $badge
    .find('.js-card-detail-due-date-badge-complete')
    .toggleClass('js-details-toggle-due-date-complete', this.model.editable());
  this.$('.js-card-detail-due-date').removeClass('hide');
  return this;
};

export const sortChecklists = function() {
  const $checklistList = this.$('.js-checklist-list');
  Util.withoutAlteringSelection(
    (function(_this) {
      return function() {
        return _this.model.checklistList.forEach(function<T>(checklist: T) {
          const checklistView = _this.existingSubview(ChecklistView, checklist);
          return $checklistList.append(checklistView.el);
        });
      };
    })(this),
  );
  return this;
};

export const removeChecklist = function<T>(checklist: T) {
  return this.deleteSubview(this.existingSubview(ChecklistView, checklist));
};

export const renderChecklists = function() {
  log('render', 'rendering checklists');
  const $checklistList = this.$('.js-checklist-list').empty();
  const subviews = function() {
    const ref = this.model.checklistList.models;
    const results = [];
    for (let i = 0, len = ref.length; i < len; i++) {
      const checklist = ref[i];
      results.push(
        this.subview(ChecklistView, checklist, {
          card: this.model,
        }),
      );
    }
    return results;
  }.call(this);
  this.appendSubviews(subviews, $checklistList);
  DragSort.refreshIfInitialized($checklistList);
  if (!!this.model && this.model.editable()) {
    DragSort.refreshCardSortable(this.$('.js-checklist-list'), {
      axis: 'y',
      handle: '.window-module-title',
      delay: 75,
      distance: 7,
      tolerance: 'pointer',
      placeholder: 'checklist placeholder',
      items: '.checklist',
      start: function(event: MouseEvent, ui: JQueryUI.SortableUIParams) {
        const _height = $(ui.helper).outerHeight();
        return $(ui.placeholder).height(_height);
      },
    });
  }
  return this;
};

export const sortStop = function(e: Event, ui: JQueryUI.SortableUIParams) {
  Util.stopPropagation(e);
  ui.item.trigger('movechecklist', [ui]);
};

export const onChecklistClick = function(e: MouseEvent) {
  Util.preventDefault(e);
  track(
    'Card Detail',
    'Add Checklist Button',
    'Open Add Checklist Menu',
    this.model.trackProperty(),
  );
  return this.addChecklistSidebar(e.target);
};

export const onChecklistShortcut = function() {
  return this.addChecklistSidebar(this.$('.js-add-checklist-menu'));
};

export const addChecklistSidebar = function(mountPoint: HTMLElement) {
  PopOver.toggle({
    elem: mountPoint,
    view: AddChecklistMenu,
    options: {
      model: this.model,
      modelCache: this.modelCache,
      cardView: this,
    },
  });
  return false;
};

export const showDueDateBadgeMenu = function(e: Event) {
  Util.stop(e);
  PopOver.toggle({
    elem: this.$('.js-details-edit-due-date'),
    view: DatePickerView,
    options: {
      model: this.model,
      modelCache: this.modelCache,
      trackingCategory: 'card detail',
    },
  });
  track(
    'Card Detail',
    'Due Date Badge',
    'Open Due Date Menu',
    this.model.trackProperty(),
  );
};

export const toggleDueDateComplete = function(e: MouseEvent) {
  const newValue = !this.model.get('dueComplete');
  this.model.update({
    dueComplete: newValue,
  });
  if (
    newValue &&
    (shouldFireConfetti(this.model.get('name')) ||
      shouldFireConfetti(this.model.getList().get('name')))
  ) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (confetti as any).default({
      angle: _.random(55, 125),
      spread: _.random(50, 70),
      particleCount: _.random(40, 75),
      origin: {
        x: e.pageX / window.innerWidth,
        y: e.pageY / window.innerHeight,
      },
    });
  }
  return track(
    'Card Detail',
    'Due Date Badge',
    newValue ? 'Marked Complete' : 'Marked Incomplete',
    this.model.trackProperty(),
  );
};

export const dueDateSidebar = function(e: Event) {
  Util.preventDefault(e);
  PopOver.toggle({
    elem: this.$('.js-add-due-date'),
    view: DatePickerView,
    options: {
      model: this.model,
      modelCache: this.modelCache,
      trackingCategory: 'card detail',
    },
  });
  track(
    'Card Detail',
    'Sidebar',
    'Open Due Date Menu',
    this.model.trackProperty(),
  );
  return false;
};

export const focusChecklistAdd = function<T>(checklist: T) {
  return this.existingSubview(ChecklistView, checklist).focusNewTaskInput();
};
